export default __webpack_public_path__ + "static/role-7405a7d0eab5fe53d1c513cd9679fb99.png";